/*
 * Define a form page to indicate if the user is an HHS employee.
 */
import css from './pages.module.css'
import { yesNoPage } from './choicePage'

export const employeePage = propOverrides => {
  const props = {
    pageId: 'employee_page',
    fieldName: 'complainant_hhs_employee',
    label: 'Are you an HHS employee, contractor, or grantee?',
    className: css.choices,
    labelClassName: css.largeLabel,
    ...propOverrides
  }

  return yesNoPage({ ...props })
}
